import React from "react";
export function StackIcon() {
 return (
  <svg
   width="24"
   height="24"
   fill="none"
   viewBox="0 0 24 24"
   xmlns="http://www.w3.org/2000/svg"
  >
   <path
    d="M4 4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H4Zm2.5 13.5A2 2 0 0 1 4.563 16H15.5a2.5 2.5 0 0 0 2.5-2.5V6.563A2 2 0 0 1 19.5 8.5v5a4 4 0 0 1-4 4h-9ZM9 20a2 2 0 0 1-1.937-1.5h9.187a4.25 4.25 0 0 0 4.25-4.25V9.063A2 2 0 0 1 22 11v3.25A5.75 5.75 0 0 1 16.25 20H9Z"
    fill="#212121"
   />
  </svg>
 );
}

export function ThumbsUpIcon() {
 return (
  <svg
   width="24"
   height="24"
   fill="none"
   viewBox="0 0 24 24"
   xmlns="http://www.w3.org/2000/svg"
  >
   <path
    d="M15.057 9.004c.46-1.427.693-2.676.693-3.753 0-2.399-.939-4.248-2.5-4.248-.847 0-1.109.505-1.437 1.747.017-.065-.163.634-.215.821-.101.36-.277.97-.527 1.831a.247.247 0 0 1-.03.065L8.175 9.953A5.885 5.885 0 0 1 5.32 12.28l-1.257.481a1.75 1.75 0 0 0-1.092 1.968l.686 3.538a2.25 2.25 0 0 0 1.673 1.757l8.25 2.022a4.75 4.75 0 0 0 5.733-3.44l1.574-6.173a2.75 2.75 0 0 0-2.665-3.429h-3.165Z"
    fill="#212121"
   />
  </svg>
 );
}
